module.exports = __webpack_public_path__ + "static/media/venom.62b74c26.jpeg";